import { useAppBanner } from '@/components/AppBanner';
import { Sidebar } from '@/components/NewSidebar';
import { AppRoutes } from '@/utils/types';
import styled from '@emotion/styled';
import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { BANNER_HEIGHT } from './AppBanner/AppBanner';

const Container = styled.div<{ isBannerOpen: boolean }>`
    background-color: ${({ theme }) => theme.colors.black[50]};
    width: 100%;
    height: ${({ isBannerOpen }) => (isBannerOpen ? `calc(100% - ${BANNER_HEIGHT})` : '100%')};
    display: flex;
`;

const ContentContainer = styled.div`
    height: 100%;
    overflow-x: hidden;
    padding: 32px;
    width: 100%;
    position: relative;
`;

interface Props {
    children: React.ReactNode;
    style?: React.CSSProperties;
    title?: string;
}

export const NewLayout = ({ children, title, style }: Props) => {
    const { isOpen } = useAppBanner();
    const { pathname, search } = useLocation();
    const ref = useRef<HTMLDivElement>(null);

    const isAgentShareGuestView = pathname === AppRoutes.AgentShare && search;

    useEffect(() => {
        ref.current?.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        if (title) {
            document.title = title;
        }
    }, [title]);

    return (
        <Container isBannerOpen={isOpen} data-testid={`page-${window.location.pathname.replace(/^\//, '')}`}>
            {!isAgentShareGuestView && <Sidebar />}
            <ContentContainer ref={ref} style={style}>
                {children}
            </ContentContainer>
        </Container>
    );
};
